import styled from 'styled-components'
import { motion } from 'framer-motion'
import {
  FONT_BASE_COLOR,
  GREY_BACKGROUND,
  SELECTED_ACTIVE_COLOR,
  CLICKABLE_COLOR,
} from '@CSSVars/colors'

export const _PhotosAndLocationMenu = styled.div`
  height: 44px;
  background-color: white;
  z-index: 500000;
  width: fit-content;
  max-width: 244px;
`

export const _MenuList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  background: ${GREY_BACKGROUND};
  border-radius: 10px;
  z-index: 1;
  padding: 4px;
`

export const _MenuItem = styled.div`
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  background-color: transparent;
  transition: background-color 0.5s ease-out;
  padding: 11px 12px;
  border-radius: 10px;
  z-index: 1;
  text-align: center;
  position: relative;
  span:hover {
    color: ${CLICKABLE_COLOR};
  }
  span:active {
    color: ${SELECTED_ACTIVE_COLOR};
  }
`
export const _Label = styled.span`
  position: relative;
  color:   ${({ isActive }) => (
    isActive ? CLICKABLE_COLOR : FONT_BASE_COLOR
  )};
    @media screen and (min-width: 375px) {
      white-space: nowrap;
    }
`

export const _Slider = styled(motion.span)`
  background: white;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px #00000026;

`
